import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const KeyListLoading = lazy(() => import('./KeyListLoading'))

class KeyListLoadingComponent extends ReactWebComponent {
  override render() {
    return (
      <AppProviders>
        <KeyListLoading />
      </AppProviders>
    )
  }
}

customElements.define('key-list-loading', KeyListLoadingComponent)
